import { createFileRoute, useParams } from '@tanstack/react-router';

import { useStudentProgress } from '@/api/me/class-progress.ts';
import { EmptyState } from '@/components/ui.tsx';
import { useAuth } from '@/store/auth.ts';
import { StudentProgressView } from '@/views/courses/detail/student-progress-view.tsx';

// 教师深入查看某学生的内容 + 作业进度。独立页面
// （此深层路径匹配时替代班级进度表格渲染）。
export const Route = createFileRoute('/_learner/courses_/$id/class-progress/students/$studentId')({
  component: StudentProgressTab,
});

function StudentProgressTab() {
  const { id, studentId } = useParams({
    from: '/_learner/courses_/$id/class-progress/students/$studentId',
  });
  const user = useAuth((s) => s.user);
  const isTeacher = user?.role === 'TEACHER' || user?.role === 'ADMIN';
  const dataQ = useStudentProgress(id, studentId);

  if (!user) return null;
  if (!isTeacher) {
    return <EmptyState>Student progress is only available to teachers.</EmptyState>;
  }
  if (dataQ.isPending) return <StudentProgressSkeleton />;
  if (dataQ.isError || !dataQ.data) {
    return <EmptyState>Could not load this student's progress.</EmptyState>;
  }
  return <StudentProgressView courseId={id} data={dataQ.data} />;
}

function StudentProgressSkeleton() {
  return (
    <div className="space-y-6" aria-hidden>
      <div className="h-24 w-full animate-pulse rounded-lg bg-neutral-100" />
      <div className="h-8 w-48 animate-pulse rounded bg-neutral-100" />
      <div className="h-48 w-full animate-pulse rounded-md bg-neutral-100" />
    </div>
  );
}
